import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./FilterFeatures.module.scss";
import {useFilterFeaturesLogic} from "./FilterFeatures.logic";
import {FilterFeatureVideoLesson} from "../filter-feature-video-lesson/FilterFeatureVideoLesson";
import {FilterFeatureArrangementTypes} from "../filter-feature-arrangement-types/FilterFeatureArrangementTypes";

export const FilterFeatures: VoidFunctionComponent = () => {
  const {isAvailable, isArrangementTypesAvailable} = useFilterFeaturesLogic();
  if (!isAvailable) {
    // not available
    return null;
  }
  return <div className={s.container}>
    {isArrangementTypesAvailable && <FilterFeatureArrangementTypes />}
    <FilterFeatureVideoLesson />
  </div>;
}
